import { useEffect, useState } from 'react';

export const useBodyRendering = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isBodyRendered, setIsBodyRendered] = useState(false);

  // Set hydration flag after component mounts (client-side only)
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Set body rendered flag after the Body has been painted
  useEffect(() => {
    if (isHydrated) {
      // Use setTimeout to ensure the DOM has been painted
      const timer = setTimeout(() => {
        setIsBodyRendered(true);
      }, 100); // Small delay to ensure Body is fully rendered

      return () => clearTimeout(timer);
    }
  }, [isHydrated]);

  return { isBodyRendered };
};
